import { VStack, HStack, Spacing, colors, ColorIcon } from "goi_common";
import { Box } from "@chakra-ui/react";

interface HomeV4ReviewCardProps {
  rating: number;
  author: string;
  date: string;
  content: React.ReactNode;
  background?: string;
  onClick?: () => void;
}

export default function HomeV4ReviewCard({
  rating,
  author,
  date,
  content,
  background = colors.gray50,
  onClick,
}: HomeV4ReviewCardProps) {
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 >= 0.5;

  return (
    <VStack
      padding="24px 20px"
      background={background}
      borderRadius="12px"
      gap={0}
      width="100%"
    >
      <HStack gap="4px" alignItems="center">
        <HStack gap="2px">
          {[...Array(5)].map((_, index) => (
            <ColorIcon
              key={index}
              name="rating_star"
              size={20}
              color={
                index < fullStars || (index === fullStars && hasHalfStar)
                  ? colors.orange650
                  : colors.gray300
              }
            />
          ))}
        </HStack>
        <Box className="subtitle_18_sb" color={colors.gray900}>
          {rating}
        </Box>
      </HStack>

      <Spacing gap={8} />

      <Box className="body_14_r" color={colors.gray600}>
        {author} | {date}
      </Box>
      <Spacing gap={16} />
      <Box className="body_16_r" color={colors.gray800} lineHeight="1.6">
        {content}
      </Box>
      <Spacing gap={20} />

      <Box width="100%" height="1px" background={colors.gray200} />
      <Spacing gap={16} />
      <Box
        as="button"
        width="100%"
        onClick={onClick}
        style={{ cursor: "pointer" }}
      >
        <HStack justifyContent="center" alignItems="center" gap="4px">
          <Box className="body_14_m" color={colors.gray700}>
            자세히 보기
          </Box>
          <ColorIcon
            name="arrow_right_small_v2"
            size={12}
            color={colors.gray700}
          />
        </HStack>
      </Box>
    </VStack>
  );
}
